import {
  USERS_FETCH_FAIL,
  USERS_FETCH_REQUEST,
  USERS_FETCH_SUCCESS,
} from "../constants/UserConstants";
import { getAllUsers } from "../services/userService";

export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: USERS_FETCH_REQUEST });

  try {
    const data = await getAllUsers();
    dispatch({ type: USERS_FETCH_SUCCESS, payload: Array.isArray(data) ? data : [] });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch users.";
    dispatch({ type: USERS_FETCH_FAIL, payload: message });
    throw error;
  }
};
